//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  components: {},
  data() {
    return {
      withdrawAmount: '',
      //为了初始哺触发弹框
      loading_state:false,
      withdrawOpenId: '',
      PageData:{},
      OpenId:"",
      wx_tx:{
        dangqian:"",
        tixian:"",
        guize:""
      },
      JIFEN: 25.0,
      show: false
    };
  },
  created () {
    this.getCashList()
  },
  mounted(){},
  computed: {
    nodeInfo () {
      return this.$store.state.nodeInfo
    },
    shengyu () {
      return this.nodeInfo.totalMoney - this.withdrawAmount
    }
  },
  methods: {
    onClickBtnWithdraw () {
      if (this.nodeInfo.totalMoney == 0) {
        return this.$msg.inform('您当前可提现余额为0')
      }
      this.show=true
    },
    async onConfirm () {
      await this.GetOpenid()
      await this.withdrawCash()
    },

    //获取提现openid
    async GetOpenid(){
      this.$msg.loading ()
      let {data} = await this.$http({
        url:this.$api.GetOnlyKey
      })
      this.$msg.hideLoading ()
      if (data.state == 1) {
        this.withdrawOpenId=data.data;
      }
    },
    async withdrawCash () {
      this.$msg.loading ()
      let {data} = await this.$http({
        url:this.$api.PassageNodeWallet,
        method: 'post',
        data: {
          OpenId: this.withdrawOpenId,
          Money: this.withdrawAmount,
          Comment: '',
        }
      })
      this.$msg.hideLoading ()
      if (data.state==1) {
        this.go_successful()
      }
    },

    go_successful () {
      this.$router.push({ path: "/mCc/nodeWalletWithdrawMsg" });
    },

    go_back() {
      this.$router.go(-1);
    },

    getCashList () {
      this.$msg.loading()
      this.$http({
        url: this.$api.GetPassageNodeCashInOrderList,
        method: 'post',
      }).then(res => {
        this.$msg.hideLoading()
        if (res.data.state == 1) {
          this.$store.commit('set_nodeInfo', {totalMoney: res.data.totalMoney})
        }
      })
    },

    checkBalance () {
      if (this.withdrawAmount > this.nodeInfo.totalMoney) {
        this.$msg.inform('超出最大可提现金额')
        this.withdrawAmount = this.nodeInfo.totalMoney
      }
    }
  },
};
